var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { memo } from 'react';
import { styled } from '@web/theme';
import { useBlock, useBlockEdit, blockEditActions } from '../../';
import { usePageEdit } from '../../../ModulePage';
export var BlockDimensions = memo(function (_a) {
    var _b, _c;
    var id = _a.id;
    var block = useBlock(id).block;
    var pageEdit = usePageEdit().pageEdit;
    var _d = useBlockEdit(), blockEdit = _d.blockEdit, dispatchBlockEdit = _d.dispatchBlockEdit;
    var onChange = function (e) {
        var _a;
        dispatchBlockEdit({
            type: blockEditActions.ADD,
            block: __assign(__assign(__assign({}, block), blockEdit.data), (_a = {}, _a[e.target.name] = e.target.value, _a))
        });
    };
    var useHeight = ((_b = blockEdit.data) === null || _b === void 0 ? void 0 : _b.height) !== undefined ? (_c = blockEdit.data) === null || _c === void 0 ? void 0 : _c.height : block.height;
    if (!pageEdit.enabled)
        return null;
    return (React.createElement(Flex, null,
        React.createElement(Label, null,
            React.createElement(HeightIcon, null),
            React.createElement(Input, { type: "number", name: "height", value: useHeight, onChange: onChange }))));
});
var WidthIcon = memo(function () {
    return React.createElement(Icon, null,
        React.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 128 128" },
            React.createElement("g", { transform: "matrix(1,0,0,1,-1176.16,-1689.94)" },
                React.createElement("g", null,
                    React.createElement("g", { transform: "matrix(0.563911,0,0,0.96041,516.452,459.938)" },
                        React.createElement("rect", { x: "1169.88", y: "1280.7", width: "226.986", height: "133.276", style: { fill: 'none' } })),
                    React.createElement("path", { d: "M1278.69,1749.89L1278.69,1741.21L1304.16,1753.94L1278.69,1766.67L1278.69,1757.99L1201.62,1757.99L1201.62,1766.67L1176.16,1753.94L1201.62,1741.21L1201.62,1749.89L1278.69,1749.89Z" })))));
});
var HeightIcon = memo(function () {
    return React.createElement(Icon, null,
        React.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 128 128" },
            React.createElement("g", { transform: "matrix(1,0,0,1,-1176.16,-1689.94)" },
                React.createElement("g", null,
                    React.createElement("g", { transform: "matrix(0.563911,0,0,0.96041,516.452,459.938)" },
                        React.createElement("rect", { x: "1169.88", y: "1280.7", width: "226.986", height: "133.276", style: { fill: 'none' } })),
                    React.createElement("g", { transform: "matrix(6.12323e-17,-1,1,6.12323e-17,-513.78,2994.09)" },
                        React.createElement("path", { d: "M1278.69,1749.89L1278.69,1741.21L1304.16,1753.94L1278.69,1766.67L1278.69,1757.99L1201.62,1757.99L1201.62,1766.67L1176.16,1753.94L1201.62,1741.21L1201.62,1749.89L1278.69,1749.89Z" }))))));
});
var Icon = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\twidth: 16px;\n\theight: 16px;\n"], ["\n\twidth: 16px;\n\theight: 16px;\n"])));
var Label = styled.label(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tmargin-left: .4em;\n"], ["\n\tmargin-left: .4em;\n"])));
var Input = styled.input(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\twidth: 60px;\n\tmargin-left: .2em;\n\toutline: none;\n\tborder: none;\n\tbackground: transparent;\n\t\n\t&:active,\n\t&:focus {\n\t\tbackground-color: rgba(255,255,255,.5);\n\t}\n"], ["\n\twidth: 60px;\n\tmargin-left: .2em;\n\toutline: none;\n\tborder: none;\n\tbackground: transparent;\n\t\n\t&:active,\n\t&:focus {\n\t\tbackground-color: rgba(255,255,255,.5);\n\t}\n"])));
var Flex = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\twidth: auto;\n\tdisplay: flex;\n"], ["\n\twidth: auto;\n\tdisplay: flex;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
